'use strict';

var internals = {};

module.exports = function (input) {
  if (!input) {
    return '';
  }

  var escaped = '';

  for (var i = 0; i < input.length; ++i) {
    var charCode = input.charCodeAt(i);

    if (internals.isSafe(charCode)) {
      escaped += input[i];
    } else {
      escaped += internals.escapeHtmlChar(charCode);
    }
  }

  return escaped;
};

internals.escapeHtmlChar = function (charCode) {
  var namedEscape = internals.namedHtml[charCode];

  if (typeof namedEscape !== 'undefined') {
    return namedEscape;
  }

  if (charCode >= 256) {
    return '&#' + charCode + ';';
  }

  var hexValue = charCode.toString(16).padStart(2, '0');
  return "&#x".concat(hexValue, ";");
};

internals.isSafe = function (charCode) {
  return typeof internals.safeCharCodes[charCode] !== 'undefined';
};

internals.namedHtml = {
  '38': '&amp;',
  '60': '&lt;',
  '62': '&gt;',
  '34': '&quot;',
  '160': '&nbsp;',
  '162': '&cent;',
  '163': '&pound;',
  '164': '&curren;',
  '169': '&copy;',
  '174': '&reg;'
};

internals.safeCharCodes = function () {
  var safe = {};

  for (var i = 32; i < 123; ++i) {
    if (i >= 97 || // a-z
    i >= 65 && i <= 90 || // A-Z
    i >= 48 && i <= 57 || // 0-9
    i === 32 || // space
    i === 46 || // .
    i === 44 || // ,
    i === 45 || // -
    i === 58 || // :
    i === 95) {
      // _
      safe[i] = null;
    }
  }

  return safe;
}();